import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../context/AppContext";

const CYCLE_ENDPOINTS = {
  gap: "/gap-assessment/cycles",
  pia: "/pia/cycles",
  tprm: "/tprm/cycles",
};

export function useAssessmentCycles(module = "gap") {
  const [cycles, setCycles] = useState([]);
  const [currentCycleId, setCurrentCycleId] = useState("");
  const [currentCycle, setCurrentCycle] = useState(null);
  const [loading, setLoading] = useState(true);

  const endpoint = CYCLE_ENDPOINTS[module] || CYCLE_ENDPOINTS.gap;

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiFetch(endpoint);
      if (res.ok) {
        const data = await res.json();
        setCycles(data.cycles || []);
        const cid = data.current_cycle_id || data.cycles?.[0]?.id || "";
        setCurrentCycleId(cid);
        setCurrentCycle(
          (data.cycles || []).find((c) => c.id === cid) || data.cycles?.[0] || null,
        );
      }
    } catch {
      /* ignore */
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { cycles, currentCycleId, currentCycle, setCurrentCycleId, loading, refresh };
}
